import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { UserView } from './UserView';
import { Convo } from './Convo';

export interface ConvoMessageRow {
  id: number;
  convo_id: number;
  message_text: string;
  created_by: string;
  created_at: string;
}

const CONVO_ACCESS_FOR_USER = `convo_id IN (SELECT id FROM public.convo_user_view WHERE user_id = '{userId}')`;
const CONVO_ACCESS_FOR_ADMIN = `convo_id IN (SELECT id from public.convo WHERE institution_id = {adminInstitutionId})`;

export const ConvoMessage: Entity<ConvoMessageRow> = {
  id: 'ConvoMessage',
  title: 'Convo Message',
  service: 'main',
  rowLabel: (row: ConvoMessageRow) => row.message_text,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.convo_message',
  },
  security: [
    {
      role: 'user',
      action: 'read',
      access: 'conditional',
      condition: CONVO_ACCESS_FOR_USER,
    },
    {
      role: 'admin',
      action: 'read',
      access: 'conditional',
      condition: [CONVO_ACCESS_FOR_USER, CONVO_ACCESS_FOR_ADMIN].join(' OR '),
    },
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: CONVO_ACCESS_FOR_ADMIN,
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    convo_id: {
      seq: 10,
      label: 'Convo',
      type: FieldType.Reference,
      listColumn: true,
      refEntity: Convo,
    },
    message_text: {
      seq: 15,
      label: 'Message Text',
      type: FieldType.Text,
    },
    created_by: {
      seq: 20,
      label: 'Created By',
      type: FieldType.Reference,
      refEntity: UserView,
    },
    created_at: {
      seq: 25,
      label: 'Created At',
      type: FieldType.Datetime,
    },
  },
};
